var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 70,
    viewBox: "0 0 116 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 70,
    rx: 7,
    fill: "#CEE8E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6693_11595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 70
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 70,
    rx: 7,
    fill: "#FEF9EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6693_11595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4459 111.635C66.0383 111.635 53.6307 111.635 41.2231 111.635C47.4253 61.0905 53.6264 10.5447 59.8254 -40C59.8329 -40 59.8405 -40 59.848 -40C66.0491 10.5447 72.248 61.0894 78.4448 111.635H78.4459Z",
    fill: "#FEF9EF",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2228 111.635C28.8152 111.635 16.4076 111.635 4 111.635C22.6022 61.0894 41.2034 10.5447 59.8035 -40C59.811 -40 59.8186 -40 59.8261 -40C53.6271 10.5447 47.426 61.0894 41.2228 111.635V111.635Z",
    fill: "#FEF9EF",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.668 111.636C103.261 111.636 90.8532 111.636 78.4445 111.636C72.2477 61.0905 66.0488 10.5458 59.8477 -39.9989C59.8552 -39.9989 59.8627 -39.9989 59.8703 -39.9989C78.4714 10.5458 97.0704 61.0905 115.668 111.636V111.636Z",
    fill: "#FEF9EF",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.483 63.2734C70.382 63.254 69.281 63.2347 68.1812 63.2153C68.4448 40.5227 102.546 40.4786 102.876 63.2153C101.709 63.2347 100.544 63.2551 99.3772 63.2745C99.1695 45.0337 71.7531 44.9907 71.483 63.2745V63.2734Z",
    fill: "#CEE8E4",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1802 63.2153C67.0793 63.196 65.9783 63.1766 64.8784 63.1572C65.1356 36.0547 105.921 35.9246 106.374 63.1551C105.207 63.1744 104.042 63.1949 102.875 63.2142C102.545 40.4786 68.4439 40.5227 68.1802 63.2153Z",
    fill: "#E9725B",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7847 63.3314C73.6838 63.3121 72.5828 63.2927 71.4829 63.2734C71.7541 44.9907 99.1705 45.0326 99.3771 63.2745C98.2105 63.2938 97.045 63.3142 95.8784 63.3336C95.7944 49.5866 75.0624 49.4586 74.7847 63.3314Z",
    fill: "#FEBD02",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1315 17.3956C52.6472 17.3763 52.1629 17.358 51.6797 17.3386C51.9584 7.44025 66.8338 7.42197 67.1416 17.3386C66.6293 17.358 66.117 17.3773 65.6037 17.3967C65.3809 9.41347 53.3822 9.39627 53.1315 17.3967V17.3956Z",
    fill: "#CEE8E4",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6793 17.3386C51.195 17.3193 50.7108 17.301 50.2275 17.2816C50.5343 5.48529 68.2863 5.43045 68.678 17.2795C68.1658 17.2988 67.6535 17.3182 67.1401 17.3376C66.8323 7.42088 51.957 7.44024 51.6783 17.3376L51.6793 17.3386Z",
    fill: "#E9725B",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5832 17.4526C54.0989 17.4333 53.6146 17.415 53.1313 17.3956C53.381 9.39518 65.3807 9.41346 65.6035 17.3956C65.0912 17.415 64.579 17.4343 64.0656 17.4537C63.9279 11.4039 54.8049 11.3491 54.5832 17.4515V17.4526Z",
    fill: "#FEBD02",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4673 43.5616C27.6828 43.5422 26.8993 43.5229 26.1147 43.5035C26.387 27.3811 50.6146 27.3499 50.9342 43.5035C50.1034 43.5229 49.2736 43.5433 48.4428 43.5626C48.2276 30.5899 28.7278 30.5598 28.4673 43.5626V43.5616Z",
    fill: "#CEE8E4",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1148 43.5046C25.3302 43.4852 24.5468 43.4659 23.7622 43.4465C24.0463 24.2046 53.0017 24.1121 53.4246 43.4444C52.5938 43.4637 51.764 43.4841 50.9332 43.5035C50.6136 27.351 26.386 27.3822 26.1137 43.5046H26.1148Z",
    fill: "#E9725B",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8189 43.6196C30.0343 43.6003 29.2509 43.5809 28.4663 43.5616C28.7268 30.5587 48.2265 30.5888 48.4418 43.5616C47.611 43.5809 46.7812 43.6003 45.9504 43.6207C45.8384 33.8266 31.0675 33.7352 30.8189 43.6186V43.6196Z",
    fill: "#FEBD02",
    stroke: "#4F4F4F",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/Community.30b44ef96b00f8e210d3fb1ec5eeedf3.svg";
export { ForwardRef as ReactComponent };